module.exports = __webpack_public_path__ + "img/circle.2510f568.svg";